import React from 'react';
import { object } from 'prop-types';
import { Grid, Header, Segment } from 'semantic-ui-react';

import PageWrap from './PageWrap';
import PasswordChangeForm from './PasswordChangeForm';
import withAuthorization from '../withAuthorization';

const Account = () => (
  <PageWrap>
    <Grid textAlign="center" style={{ height: '100%' }} verticalAlign="middle">
      <Grid.Column style={{ maxWidth: 450 }}>
        <Segment>
          <Header as="h2" color="blue" textAlign="left">
            Set a New Password
          </Header>
          <PasswordChangeForm />
        </Segment>
      </Grid.Column>
    </Grid>
  </PageWrap>
);

Account.contextTypes = {
  authUser: object,
};

const authCondition = authUser => !!authUser;

export default withAuthorization(authCondition)(Account);



// WEBPACK FOOTER //
// ./src/components/Account.jsx